import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16cee591"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "leads-details-tabs" }
const _hoisted_4 = {
  class: "nav nav-tabs border-0 mb-25",
  id: "myTab",
  role: "tablist"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-warning"
}
const _hoisted_8 = {
  key: 1,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-info"
}
const _hoisted_9 = {
  key: 2,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-success"
}
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = {
  key: 0,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-warning"
}
const _hoisted_12 = {
  key: 1,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-info"
}
const _hoisted_13 = {
  key: 2,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-success"
}
const _hoisted_14 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-success"
}
const _hoisted_17 = {
  key: 1,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-info"
}
const _hoisted_18 = {
  key: 2,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-info"
}
const _hoisted_19 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-warning"
}
const _hoisted_22 = {
  key: 1,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger"
}
const _hoisted_23 = {
  key: 2,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger"
}
const _hoisted_24 = {
  key: 3,
  class: "position-absolute top-0 start-50 translate-middle badge rounded-pill bg-success"
}
const _hoisted_25 = {
  key: 0,
  class: "col-12"
}
const _hoisted_26 = {
  key: 1,
  class: "col-lg-5 col-xl-4"
}
const _hoisted_27 = { class: "col-lg-7 col-xl-8" }
const _hoisted_28 = {
  class: "tab-content",
  id: "tabContent"
}
const _hoisted_29 = {
  class: "tab-pane fade show active",
  id: "gci-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_30 = {
  class: "tab-pane fade",
  id: "impact-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_31 = { class: "card-body pt-0 pb-0 pb-sm-2 pb-md-25 pb-lg-2 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_32 = { class: "row d-flex" }
const _hoisted_33 = {
  key: 0,
  class: "d-flex flex-wrap align-items-center mb-25 mt-30"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 me-2 mt-1" }, "Kapor's Gap-Index:", -1))
const _hoisted_35 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-8" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-12" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 2,
  class: "alert alert-warning fs-12",
  role: "alert"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Partial data used for report; may affect gap-closing categorization.", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<h5 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-12\" data-v-16cee591></span></h5><h5 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-11\" data-v-16cee591></span></h5><h5 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-12\" data-v-16cee591></span></h5><h5 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-9\" data-v-16cee591></span></h5><h5 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-11\" data-v-16cee591></span></h5>", 5)
const _hoisted_50 = {
  key: 5,
  class: "d-flex flex-wrap align-items-center mb-25 mt-20"
}
const _hoisted_51 = {
  key: 0,
  class: "col-md-6 mt-25"
}
const _hoisted_52 = {
  key: 0,
  class: "chart"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<h1 class=\"placeholder-glow mt-30\" data-v-16cee591><span class=\"placeholder col-12\" data-v-16cee591></span></h1><h1 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-12\" data-v-16cee591></span></h1><h5 class=\"placeholder-glow\" data-v-16cee591><span class=\"placeholder col-9\" data-v-16cee591></span></h5>", 3)
const _hoisted_57 = [
  _hoisted_54
]
const _hoisted_58 = {
  key: 0,
  class: "tab-pane fade",
  id: "team-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_59 = {
  key: 0,
  class: "tab-pane fade",
  id: "company-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_60 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-25 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Overview")
], -1))
const _hoisted_62 = { class: "card-body pt-0 pb-0 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Mission:", -1))
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Business Model: ", -1))
const _hoisted_67 = { key: 2 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Target Audience:", -1))
const _hoisted_69 = { key: 3 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pricing:", -1))
const _hoisted_71 = { key: 4 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Free Tier/Trial:", -1))
const _hoisted_73 = {
  key: 2,
  class: "tab-pane fade",
  id: "company-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-25 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "No Data Found")
  ])
], -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  class: "tab-pane fade",
  id: "custom-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "competition-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-25 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-3" }, "This feature is in development")
    ])
  ])
], -1))
const _hoisted_78 = {
  key: 1,
  class: "col-lg-12"
}
const _hoisted_79 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_80 = { class: "card-head bg-white pt-25 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-20" }, "Manual Analysis Required", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Due to limited information about this company we are unable to provide a full analysis with confidence.", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Below is the information we have on file.", -1))
const _hoisted_84 = { class: "d-block" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "I have logged this issue so a team member can look at this issue!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyReportProgress = _resolveComponent("CompanyReportProgress")!
  const _component_CompanyAlignmentCard = _resolveComponent("CompanyAlignmentCard")!
  const _component_CompanyInformation = _resolveComponent("CompanyInformation")!
  const _component_CompanyReputationCard = _resolveComponent("CompanyReputationCard")!
  const _component_CompanyOverviewCard = _resolveComponent("CompanyOverviewCard")!
  const _component_CompanyPlaceholderCard = _resolveComponent("CompanyPlaceholderCard")!
  const _component_CompanyCustomAnswersCard = _resolveComponent("CompanyCustomAnswersCard")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_CompanyTextCard = _resolveComponent("CompanyTextCard")!
  const _component_CompanyFounderCard = _resolveComponent("CompanyFounderCard")!
  const _component_CompanyResearchCard = _resolveComponent("CompanyResearchCard")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.company && _ctx.progress_bar && _ctx.company.incomplete_inbound_report !== true)
      ? (_openBlock(), _createBlock(_component_CompanyReportProgress, {
          key: 0,
          is_streaming: _ctx.is_streaming,
          is_streaming_complete: _ctx.is_streaming_complete,
          progress_bar: _ctx.progress_bar,
          company: _ctx.company,
          is_research_complete: _ctx.is_research_complete,
          reportVisible: _ctx.reportVisible,
          company_research_data: _ctx.company_research_data
        }, null, 8, ["is_streaming", "is_streaming_complete", "progress_bar", "company", "is_research_complete", "reportVisible", "company_research_data"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.company && _ctx.company.incomplete_inbound_report !== true)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("ul", _hoisted_4, [
                  _createElementVNode("li", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 active position-relative",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'gci')),
                      id: "gci-tab",
                      "data-bs-toggle": "tab",
                      "data-bs-target": "#gci-tab-pane",
                      type: "button",
                      role: "tab",
                      "aria-controls": "gci-tab-pane",
                      "aria-selected": "true",
                      disabled: !_ctx.company_research_data
                    }, [
                      _createTextVNode(" Screening "),
                      (_ctx.had_streaming && !_ctx.is_research_complete && !_ctx.is_streaming_complete)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Researching "))
                        : _createCommentVNode("", true),
                      (_ctx.had_streaming && _ctx.is_research_complete && !_ctx.is_streaming_complete)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            (_ctx.company.gap_closing_category.CUR.analysis)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("1 out of 1")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("In Progress...")
                                ], 64))
                          ]))
                        : (_ctx.had_streaming && _ctx.is_research_complete && _ctx.is_streaming_complete)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Done "))
                          : _createCommentVNode("", true)
                    ], 8, _hoisted_6)
                  ]),
                  _createElementVNode("li", _hoisted_10, [
                    _createElementVNode("button", {
                      class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 position-relative",
                      id: "impact-tab",
                      "data-bs-toggle": "tab",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'impact')),
                      "data-bs-target": "#impact-tab-pane",
                      type: "button",
                      role: "tab",
                      "aria-controls": "impact-tab-pane",
                      "aria-selected": "false"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.isMobileView ? 'Gap Index' : 'Kapor\'s Gap-Index') + " ", 1),
                      (_ctx.had_streaming && !_ctx.is_research_complete && !_ctx.is_streaming_complete)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Researching "))
                        : _createCommentVNode("", true),
                      (_ctx.had_streaming && _ctx.is_research_complete && !_ctx.is_streaming_complete)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            (_ctx.company.supplemental_data.investment_questions)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("3 out of 3")
                                ], 64))
                              : (_ctx.company.gap_closing_category.AVG.analysis)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("2 out of 3")
                                  ], 64))
                                : (_ctx.company.gap_closing_category.POT.analysis)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode("1 out of 3")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode("In Progress...")
                                    ], 64))
                          ]))
                        : (_ctx.had_streaming && _ctx.is_research_complete && _ctx.is_streaming_complete)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Done "))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 position-relative",
                      id: "company-tab",
                      "data-bs-toggle": "tab",
                      "data-bs-target": "#company-tab-pane",
                      type: "button",
                      role: "tab",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'company')),
                      "aria-controls": "company-tab-pane",
                      "aria-selected": "false",
                      disabled: !_ctx.company_research_data
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.isMobileView ? 'Research' : 'Company Research') + " ", 1),
                      (_ctx.had_streaming && _ctx.is_research_complete && _ctx.company_research_data)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Done "))
                        : (_ctx.had_streaming && !_ctx.is_research_complete && _ctx.completed_research_count && _ctx.company_research_display_order)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.completed_research_count) + " out of " + _toDisplayString(_ctx.company_research_display_order.length), 1))
                          : (_ctx.had_streaming && !_ctx.is_research_complete && _ctx.company_research_display_order)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 0 out of " + _toDisplayString(_ctx.company_research_display_order.length), 1))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_15)
                  ]),
                  _createElementVNode("li", _hoisted_19, [
                    _createElementVNode("button", {
                      class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 position-relative",
                      id: "team-tab",
                      "data-bs-toggle": "tab",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'team')),
                      "data-bs-target": "#team-tab-pane",
                      type: "button",
                      role: "tab",
                      "aria-controls": "team-tab-pane",
                      "aria-selected": "false",
                      disabled: !_ctx.company_research_data || !_ctx.company_research_data.INFO || !_ctx.company_research_data.INFO.founders || _ctx.company_research_data.INFO.founders.length <= 0
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.isMobileView ? 'Team' : 'Team Research') + " ", 1),
                      (_ctx.had_streaming && !_ctx.is_research_complete)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Researching.. "))
                        : (_ctx.had_streaming && _ctx.is_research_complete && (!_ctx.company_research_data || !_ctx.company_research_data.INFO || !_ctx.company_research_data.INFO.founders || _ctx.company_research_data.INFO.founders.length <= 0))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " No Data Found "))
                          : (!_ctx.had_streaming && _ctx.report_exists_and_complete && _ctx.is_research_complete && (!_ctx.company_research_data || !_ctx.company_research_data.INFO || !_ctx.company_research_data.INFO.founders || _ctx.company_research_data.INFO.founders.length <= 0))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " No Data Found "))
                            : (_ctx.had_streaming && _ctx.is_research_complete)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Done "))
                              : _createCommentVNode("", true)
                    ], 8, _hoisted_20)
                  ])
                ])
              ])
            ]),
            (_ctx.canAccessFeature('inboundList') && !_ctx.is_streaming && _ctx.company && _ctx.company?.thesis_failed_filters?.totals?.applied_filters && _ctx.isMobileView && _ctx.company.incomplete_inbound_report !== true && _ctx.activeTab === 'gci')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_CompanyAlignmentCard, { company: _ctx.company }, null, 8, ["company"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isMobileView || (_ctx.isMobileView && _ctx.activeTab === 'gci'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_ctx.company)
                    ? (_openBlock(), _createBlock(_component_CompanyInformation, {
                        key: 0,
                        company: _ctx.company,
                        company_research_data: _ctx.company_research_data,
                        onGoToTab: _ctx.handleGoToTab,
                        onUpdateCompany: _ctx.handleCompanyUpdate
                      }, null, 8, ["company", "company_research_data", "onGoToTab", "onUpdateCompany"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.canAccessFeature('inboundList') && !_ctx.is_streaming && _ctx.company && _ctx.company?.thesis_failed_filters?.totals?.applied_filters && !_ctx.isMobileView)
                      ? (_openBlock(), _createBlock(_component_CompanyAlignmentCard, {
                          key: 0,
                          company: _ctx.company
                        }, null, 8, ["company"]))
                      : _createCommentVNode("", true),
                    (_ctx.company)
                      ? (_openBlock(), _createBlock(_component_CompanyReputationCard, {
                          key: 1,
                          flags: _ctx.company.reputation_risks.flags,
                          content: _ctx.company.reputation_risks.analysis,
                          title: 'Reputation Concerns',
                          content_id: 'reputation_risks',
                          global_tag: _ctx.GLOBAL_TAG,
                          onGoToTab: _ctx.handleGoToTab
                        }, null, 8, ["flags", "content", "global_tag", "onGoToTab"]))
                      : _createCommentVNode("", true),
                    (_ctx.company.gap_closing_category.CUR.analysis)
                      ? (_openBlock(), _createBlock(_component_CompanyOverviewCard, {
                          key: 2,
                          content: _ctx.company.gap_closing_category.CUR.analysis,
                          title: 'About ' + _ctx.company.name,
                          content_id: 'current_gap_analysis',
                          global_tag: _ctx.GLOBAL_TAG,
                          onGoToTab: _ctx.handleGoToTab
                        }, null, 8, ["content", "title", "global_tag", "onGoToTab"]))
                      : (_openBlock(), _createBlock(_component_CompanyPlaceholderCard, { key: 3 })),
                    (_ctx.canAccessFeature('inboundList') && !_ctx.is_streaming && _ctx.company && _ctx.company?.customAnswers)
                      ? (_openBlock(), _createBlock(_component_CompanyCustomAnswersCard, {
                          key: 4,
                          customAnswers: _ctx.company?.customAnswers,
                          referenceDocuments: _ctx.company?.referenceDocuments,
                          inboundEmailBody: _ctx.company?.inboundEmailBody,
                          id: "custom-report-card"
                        }, null, 8, ["customAnswers", "referenceDocuments", "inboundEmailBody"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['card', 'mb-25', 'rounded-0', 'bg-white', 'letter-spacing', _ctx.GLOBAL_TAG === 'averaged_gap_analysis' ? 'border border-1 border-info' : 'border-0']),
                      id: "averaged_gap_analysis"
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.companyChart.labels.length <= 0 ? 'col-md-12' : 'col-md-6')
                          }, [
                            (_ctx.company)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _hoisted_34,
                                  (_ctx.company.gap_closing_category && _ctx.company.gap_closing_category.AVG.title)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass({
      'badge rounded-pill fs-13 me-2 mt-1': true,
      'text-bg-secondary': _ctx.company.gap_closing_category.AVG.title.toLowerCase().includes('neutral') == true,
      'text-bg-success': _ctx.company.gap_closing_category.AVG.title.toLowerCase().includes('closing') == true,
      'text-bg-warning': _ctx.company.gap_closing_category.AVG.title.toLowerCase().includes('widening') == true,
    })
                                      }, _toDisplayString(_ctx.company.gap_closing_category.AVG.title), 3))
                                    : (_openBlock(), _createElementBlock("h5", _hoisted_35, _hoisted_37))
                                ]))
                              : (_openBlock(), _createElementBlock("h5", _hoisted_38, _hoisted_40)),
                            (_ctx.company.partial_report)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                              : _createCommentVNode("", true),
                            (_ctx.company.gap_closing_category.AVG.analysis)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 3,
                                  id: "averaged_gap_analysis",
                                  innerHTML: _ctx.company.gap_closing_category.AVG.analysis
                                }, null, 8, _hoisted_44))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _hoisted_45
                                ], 64)),
                            (_ctx.company)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  (_ctx.company.references_count > 0 && _ctx.company.references_count <= 5)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "badge text-bg-warning fs-12 me-2 mt-1 cursor-pointer",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleGoToTab('gci', 'references')))
                                      }, "Citation Score: Low"))
                                    : _createCommentVNode("", true),
                                  (_ctx.company.references_count >= 6 && _ctx.company.references_count <= 14)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: "badge text-bg-secondary fs-12 me-2 mt-1 cursor-pointer",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleGoToTab('gci', 'references')))
                                      }, "Citation Score: Moderate"))
                                    : _createCommentVNode("", true),
                                  (_ctx.company.references_count >= 15)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        class: "badge text-bg-primary fs-12 me-2 mt-1 cursor-pointer",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleGoToTab('gci', 'references')))
                                      }, "Citation Score: High"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          (_ctx.companyChart.labels.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                (_ctx.company.name && !_ctx.is_streaming)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                      _createVNode(_component_apexchart, {
                                        ref: "chartRef",
                                        type: "bar",
                                        options: _ctx.companyChart,
                                        series: _ctx.gap_scores,
                                        height: "325px",
                                        redrawOnUpdate: true
                                      }, null, 8, ["options", "series"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_57))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2),
                    (_ctx.company.supplemental_data.investment_questions)
                      ? (_openBlock(), _createBlock(_component_CompanyTextCard, {
                          key: 0,
                          content: _ctx.company.supplemental_data.investment_questions,
                          title: 'Investment Questions',
                          content_id: 'investment_questions',
                          global_tag: _ctx.GLOBAL_TAG
                        }, null, 8, ["content", "global_tag"]))
                      : (_openBlock(), _createBlock(_component_CompanyPlaceholderCard, { key: 1 })),
                    (_ctx.company.gap_closing_category.POT.analysis)
                      ? (_openBlock(), _createBlock(_component_CompanyTextCard, {
                          key: 2,
                          content: _ctx.company.gap_closing_category.POT.analysis,
                          title: 'Maximizing Impact',
                          content_id: 'potential_gap_analysis',
                          global_tag: _ctx.GLOBAL_TAG
                        }, null, 8, ["content", "global_tag"]))
                      : (_openBlock(), _createBlock(_component_CompanyPlaceholderCard, { key: 3 })),
                    (_ctx.company.references)
                      ? (_openBlock(), _createBlock(_component_CompanyTextCard, {
                          key: 4,
                          content: _ctx.company.references,
                          title: 'Data Used for Report',
                          content_id: 'references'
                        }, null, 8, ["content"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.company_research_data && _ctx.company_research_data.INFO && _ctx.company_research_data.INFO.founders && _ctx.company_research_data.INFO.founders.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company_research_data.INFO.founders, (founder, index) => {
                          return (_openBlock(), _createBlock(_component_CompanyFounderCard, {
                            key: index,
                            founder: founder
                          }, null, 8, ["founder"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.company_research_data)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.company_research_data.INFO !== null || _ctx.company_research_data.TARAUD !== null || _ctx.company_research_data.BIPOCBEN !== null || _ctx.company_research_data.PRODCOST !== null || _ctx.company_research_data.PROD !== null || _ctx.company_research_data.NEWS !== null || _ctx.company_research_data.REVIEWS !== null || _ctx.company_research_data.EREVIEWS !== null || _ctx.company_research_data.UREVIEWS !== null || _ctx.company_research_data.LEGAL !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              (_ctx.company_research_data.INFO && _ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                    _hoisted_61,
                                    _createElementVNode("div", _hoisted_62, [
                                      (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.mission)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_63, [
                                            _hoisted_64,
                                            _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.mission.mission), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.sales_strategies.business_type)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_65, [
                                            _hoisted_66,
                                            _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.sales_strategies.business_type), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.sales_strategies.purchasers)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_67, [
                                            _hoisted_68,
                                            _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.sales_strategies.purchasers) + " - " + _toDisplayString(_ctx.company.raw_data[0].raw_json.sales_strategies.target_audience), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json && _ctx.company.raw_data[0].raw_json.product_pricing.product_costs)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_69, [
                                            _hoisted_70,
                                            _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.product_pricing.product_costs), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.company.raw_data && _ctx.company.raw_data[0] && _ctx.company.raw_data[0].raw_json.product_pricing.free_tier !== null && _ctx.company.raw_data[0].raw_json.product_pricing.free_tier !== 'null')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                                            _hoisted_72,
                                            _createTextVNode(" " + _toDisplayString(_ctx.company.raw_data[0].raw_json.product_pricing.free_tier), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (!_ctx.company_research_data)
                                      ? (_openBlock(), _createBlock(_component_CompanyPlaceholderCard, { key: 0 }))
                                      : _createCommentVNode("", true)
                                  ], 64)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company_research_display_order, (key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                  (_ctx.company_research_data[key] !== null || _ctx.company_research_data[key] !== '')
                                    ? (_openBlock(), _createBlock(_component_CompanyResearchCard, {
                                        key: 0,
                                        content: _ctx.company_research_data[key],
                                        title: _ctx.research_data_title_map[key],
                                        content_id: 'report-' + key
                                      }, null, 8, ["content", "title", "content_id"]))
                                    : (_openBlock(), _createBlock(_component_CompanyPlaceholderCard, { key: 1 }))
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75)),
                  _createElementVNode("div", _hoisted_76, [
                    _createVNode(_component_CompanyCustomAnswersCard, {
                      customAnswers: _ctx.company?.customAnswers,
                      referenceDocuments: _ctx.company?.referenceDocuments,
                      inboundEmailBody: _ctx.company?.inboundEmailBody,
                      companyID: _ctx.company?.id,
                      id: "custom-report-card"
                    }, null, 8, ["customAnswers", "referenceDocuments", "inboundEmailBody", "companyID"])
                  ]),
                  _hoisted_77
                ])
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _hoisted_82,
                _hoisted_83,
                _createVNode(_component_CompanyCustomAnswersCard, {
                  customAnswers: _ctx.company?.customAnswers,
                  referenceDocuments: _ctx.company?.referenceDocuments,
                  inboundEmailBody: _ctx.company?.inboundEmailBody,
                  id: "custom-report-card"
                }, null, 8, ["customAnswers", "referenceDocuments", "inboundEmailBody"])
              ])
            ])
          ]))
    ]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.error_modal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.error_modal) = $event)),
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      centered: "",
      title: "Something seems off...",
      "hide-header": "",
      "hide-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.error_modal_content), 1)
          ]),
          _hoisted_85
        ]),
        _createVNode(_component_b_button, {
          class: "mt-3",
          block: "",
          onClick: _ctx.goBackToSearch
        }, {
          default: _withCtx(() => [
            _createTextVNode("Go back to search page")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}